import { Link } from 'react-router-dom';
import { brandAssets } from '../../content/brandAssets';

export default function BrandLogo({
  asLink = true,
  className = '',
  imageClassName = 'h-9 w-auto object-contain',
}) {
  const image = (
    <img
      src={brandAssets.logo}
      alt="FastWhistle"
      className={imageClassName}
      width={360}
      height={86}
      loading="lazy"
      decoding="async"
    />
  );

  const content = <span className="inline-flex items-center">{image}</span>;

  if (!asLink) {
    return <div className={className}>{content}</div>;
  }

  return (
    <Link to="/" className={`inline-flex items-center ${className}`} aria-label="FastWhistle home">
      {content}
    </Link>
  );
}
